module.exports = __webpack_public_path__ + "static/media/Banner_Compendio_Completo_25.a9809ae7.jpg";